export default "__VITE_ASSET__BSmLo3Zu__"